import PrivacyPolicy from "../components/PrivacyPolicy";
import AISalesAgent from "../pages/AISalesAg";
import Blog from "../pages/Blog";
import BlogDetails from "../pages/BlogDetails";
import BookADemo from "../pages/BookADemo";
import Home from "../pages/Home";
import Login from "../pages/Login";

export const publicRoutes = [
    {
        path: "/login",
        component: <Login />
    },
    {
        path: "/",
        component: <Home />
    },
    {
        path: "/blogs",
        component: <Blog />
    },
    {
        path: "/blogs/:id",
        component: <BlogDetails />
    },
    {
        path: "/book-a-demo",
        component: <BookADemo />
    },
    {
        path: "/ai-sales-agent",
        component: <AISalesAgent />
    },
    {
        path: "/privacy-policy",
        component: <PrivacyPolicy />
    },
];